import images from "./images";

const About = {
  sub: "about us",
  heading: "Tea the way it was meant to be.",
  important: "Savor the authentic essence of tea, lovingly steeped from handpicked leaves and centuries-old traditions.",
  description: [
    "At our tea shop, we see tea as more than a beverage — it's a tradition, a moment of calm, and a celebration of nature. From leaf to cup, every blend is prepared with care, using premium, ethically sourced ingredients. Whether you're seeking a refreshing start to your day or a soothing evening brew, we offer a tea experience that honors its roots and satisfies the soul."
  ],
  image: {
    src: images.about,
    alt: "About-Image",
  },
  button: {
    text: "contact us",
    link: "Contact-us",
  },
};

export default About;